(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("styled-components"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "styled-components", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["sofa"] = factory(require("react"), require("styled-components"), require("react-dom"));
	else
		root["sofa"] = factory(root["react"], root["styled-components"], root["react-dom"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__39155__, __WEBPACK_EXTERNAL_MODULE__88694__, __WEBPACK_EXTERNAL_MODULE__69514__) => {
return 